<template>
    <span class="wrapper" v-if="showFilterFlyout">
        <h3>{{ name }}</h3>

        <div
            class="flyout"
            :class="{ active: flyoutVisible }"
            v-closable="{
                exclude: ['exclude-button'],
                handler: 'close',
            }"
        >
            <div class="content">
                <slot></slot>
            </div>
        </div>
    </span>
</template>

<script>
export default {
    data() {
        return {
            flyoutVisible: false,
        }
    },

    props: ['name', 'isActive', 'isModified'],

    computed: {
        showFilterFlyout: function () {
            return this.themeSetting('hide_product_type_filter') !== true
        },
    },
    methods: {
        close: function () {
            this.flyoutVisible = false
        },
        open: function () {
            this.flyoutVisible = true
        },
        toggleFlyout: function () {
            this.flyoutVisible = !this.flyoutVisible
        },
        save: function () {
            this.$emit('save')
            this.close()
        },
        clear: function () {
            this.$emit('clear')
            this.close()
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/settings/variables';
@import '~scss/mixins/rem';

.wrapper {
    position: relative;

    h3 {
        font-size: rem(20px);
        font-weight: bold;
        margin-top: 32px;
        margin-bottom: 12px;
    }

    .filter-button {
        color: $color-black;
        margin-right: 12px;
    }

    .flyout {
        padding: 0;
        width: 400px;

        .content {
            margin: 30px;
        }

        // always visible inside mobile menu

        visibility: visible;
        opacity: 1;
        position: relative;
        left: 0;
        top: 0;
        min-width: 0;
        width: 100%;
        box-shadow: none;
        border: none;
        padding-bottom: 34px;
        border-radius: 0;
        border-bottom: 1px solid #e3e3e3;
        overflow: initial;

        .content {
            margin: 0;
        }

        .footer {
            display: flex;
            border-top: 1px solid $color-grey;

            .clear-button {
                display: inline-block;
                height: 40px;
                line-height: 40px;
                margin: 16px;
                font-size: rem(15px);
                font-weight: bold;
                color: $text-lighter;
                cursor: pointer;
            }

            .button {
                width: initial;
                height: 40px;
                margin: 16px;
                margin-left: auto;
                font-size: rem(15px);
                line-height: unset;
            }
        }
    }

    &:last-of-type {
        .flyout {
            border-bottom: none;
        }
    }
}
</style>
